import Api from '@api/shou_xie/setMeal'
import { PUBLISH_CASE_PATH_A, PUBLISH_EXAMPLE_INNER } from '@constant'
import BaseStore from '@store/table'
import { isStoreAccount, isStoreHidden, statistic } from '@util'
import { message, Modal } from 'hljd'
import { action, observable } from 'mobx'

class Store extends BaseStore {
  $beforeGet = async () => {
    await this.getMenuList()
    return (this.$beforeGet = null)
  }

  $listApi = Api.draftCastList
  searchBar = null

  @observable merchantInfo = {}
  @observable merchant_category_id = ''
  @action
  updateMerchantInfo = data => {
    this.merchantInfo = data || {}
  }

  @action
  setStoreData = (type, value, ajax = false) => {
    this[type] = value
    if (ajax) {
      this.$getList(1)
    }
  }

  $getParams = () => {
    return {
      ...this.$params,
      merchantCategoryId: this.merchant_category_id,
      pageSize: this.$pagination.pageSize,
      pageNum: this.$pagination.current
    }
  }

  @action
  toEdit = record => () => {
    let msg = isStoreHidden()
    if (record.is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可编辑'
      })
    }
    if (msg == 'success') {
      window.open(`${PUBLISH_CASE_PATH_A}?draftId=${record.id}`)
    } else {
      return message.error(msg)
    }
  }
  showModalFn = (id, sold, flag, is_in_brand) => () => {
    if (is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可编辑'
      })
    }
    let msg = isStoreHidden()
    if (sold !== 'del' && msg != 'success') {
      message.error(msg)
      return false
    }
    let that = this
    Modal.confirm({
      content:
        sold == 'del'
          ? '确认要删除该案例吗'
          : sold == true
            ? '确认要上架吗'
            : '确认要下架吗',
      onOk() {
        if (sold == 'del') {
          that.deleteSetMealFn(id, flag)
        } else {
          that.soldOutFn(id, sold)
        }
      }
    })
  }

  showModalMove = (id, flag, is_in_brand) => () => {
    if (is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可移除'
      })
    }
    Modal.confirm({
      content: '你是否确认移除该案例，该操作不可恢复',
      onOk: () => {
        this.deleteSetMealFn(id, flag)
      }
    })
  }

  //删除普通套餐
  async deleteSetMealFn(id, flag) {
    const { success } = await Api.deleteSetMeal({ id })
    if (success) {
      if (flag == 1) {
        this.$getList(1)
      } else {
        window.location.reload()
      }
    }
  }

  // @observable categoryRequested = false
  @observable menuList = []
  @observable delCaseVisible = false
  @action
  getMenuList = async (changeId = true) => {
    const { data } = await Api.getMenuList({ isFilterItem: 1, isDraft: 1 })
    this.menuList = data.list || []
    // this.categoryRequested = true
    if (changeId) {
      this.merchant_category_id = data.list[0].id
    }
  }

  @action changeDelCaseVisible = val => (this.delCaseVisible = val)

  @action
  publishFn = async () => {
    statistic(PUBLISH_EXAMPLE_INNER)
    let msg = isStoreHidden()
    if (msg != 'success') {
      message.error(msg)
      return false
    }
    const isConsult = await this._queryConsultCountList()
    if (isConsult == 1) {
      this.delCaseVisible = true
      return
    }
    if (isStoreAccount()) {
      window.location.href = '#/localMerchant/case/publish/chooseProperty'
    } else {
      window.location.href = `${PUBLISH_CASE_PATH_A}?propertyId=${
        this.merchantInfo.property_id
      }`
    }
  }

  @action
  delDraft = async id => {
    await Api.delDraft({ id })
    await this.getMenuList(false)
    this.$getList(1)
  }
  // 添加案例分类
  // 添加案例分类
  @action
  submitCasseCate = async value => {
    let { success } = value.id
      ? await Api.editCase(value)
      : await Api.categoryAdd(value)
    if (success) {
      this.getMenuList()
    }
  }

  _queryConsultCountList = async () => {
    const { success, data } = await Api.getConsultCount()
    if (success) {
      return data
    }
  }
}
export default Store
